import { HStack, Avatar, Box, Text, Badge } from "@chakra-ui/react";

import { ReactComponent as Check } from "assets/svg/icons-new/check.svg";
// import User from "assets/profile.svg";

const ProfileShortInfo = ({ fullName, verified, kycLevel }) => {
  const getLevelColor = (level) => {
    const levelColorMap = {
      one: "red",
      two: "yellow",
      three: "green",
    };

    return levelColorMap[level];
  };

  return (
    <HStack gridGap="8px" alignSelf="flex-start">
      <Avatar
        name={fullName}
        boxSize={{ base: "40px", lg: "80px" }}
        // src={User}
      />
      <Box>
        <HStack className="hstack">
          <Text fontWeight="600" fontSize="1.2em">
            {fullName}
          </Text>
          {kycLevel && (
            <Badge colorScheme={getLevelColor(kycLevel)}>
              level {kycLevel}
            </Badge>
          )}
        </HStack>
        <HStack fontWeight="500" fontSize=".9em" color="#A0A3BD">
          <Check height={"20px"} width={"20px"} color="green" />
          <Text>{verified ? "Verified" : "Unverified"}</Text>
        </HStack>
      </Box>
    </HStack>
  );
};

export default ProfileShortInfo;
